var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalonW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3447 19.9995L23.1722 17.7139H24.8273L25.6548 19.9995",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 17.6466V13.7142C23.9995 12.7668 24.7399 12 25.6545 12C26.5692 12 27.3096 12.7668 27.3096 13.7142V15.1427C27.3096 15.9313 27.9274 16.5712 28.6888 16.5712C29.4501 16.5712 30.068 15.9313 30.068 15.1427V12",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2759 19.9993H15.7241C11.4582 19.9993 8 23.5812 8 27.9997C8 32.4181 11.4582 36 15.7241 36C17.8273 36 19.7319 35.1268 21.1255 33.7142H26.8745C28.2681 35.1268 30.1727 36 32.2759 36C36.5418 36 40 32.4181 40 27.9997C40 23.5812 36.5418 19.9993 32.2759 19.9993Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.724 30.2856H14.6206V24.5716H15.724V30.2856Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4136 26.8569H17.9303V27.9998H12.4136V26.8569Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3792 29.7142C33.3792 30.0297 33.1321 30.2856 32.8276 30.2856C32.523 30.2856 32.2759 30.0297 32.2759 29.7142C32.2759 29.3988 32.523 29.1428 32.8276 29.1428C33.1321 29.1428 33.3792 29.3988 33.3792 29.7142Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3792 25.1425C33.3792 25.4579 33.1321 25.7139 32.8276 25.7139C32.523 25.7139 32.2759 25.4579 32.2759 25.1425C32.2759 24.827 32.523 24.5711 32.8276 24.5711C33.1321 24.5711 33.3792 24.827 33.3792 25.1425Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.62 27.9998C30.3155 27.9998 30.0684 27.7438 30.0684 27.4284C30.0684 27.1129 30.3155 26.8569 30.62 26.8569C30.9246 26.8569 31.1717 27.1129 31.1717 27.4284C31.1717 27.7438 30.9246 27.9998 30.62 27.9998Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0346 27.9998C34.7301 27.9998 34.4829 27.7438 34.4829 27.4284C34.4829 27.1129 34.7301 26.8569 35.0346 26.8569C35.3391 26.8569 35.5863 27.1129 35.5863 27.4284C35.5863 27.7438 35.3391 27.9998 35.0346 27.9998Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonW);
export default __webpack_public_path__ + "static/media/salon-w.df831be6e596698890545a254e8a5c75.svg";
export { ForwardRef as ReactComponent };